import { Tag, WImage, WLink } from '@components/atoms'
import useTrans from '@hooks/useTrans'
import { ProgettiNode } from '@gql/graphql'
import styles from './ProgettoCard.module.sass'

interface Props {
  className?: string
  item?: ProgettiNode
  onClick?: () => void
}

const ProgettoCard = (props: Props) => {
  const { className = '', item, onClick } = props

  const t = useTrans()
  const classNames = `${styles.root} ${className}`

  const getContent = () => (
    <>
      <div className={styles.imageBox}>
        <WImage
          src={item.imageUrl}
          maxWidth={295}
          maxHeight={295}
          alt={item?.imageAlt}
          title={item?.imageAlt}
          objectFit="cover"
        />

        <div className={styles.containerTags}>
          {item?.destinazioni &&
            item.destinazioni.length > 0 &&
            item.destinazioni.map((destinazione) => (
              <Tag label={destinazione.titolo} className={styles.tag} />
            ))}
        </div>

        {item?.premio ? (
          <div className={styles.listingBrand}>
            <WImage maxWidth={81} maxHeight={47} src={item?.premio} alt={item?.imageAlt} />
          </div>
        ) : null}
      </div>
      <div className={styles.content}>
        {!!item.title && <h3 className={styles.title}>{item.title}</h3>}
      </div>
    </>
  )

  return item ? (
    item?.url ? (
      <WLink href={item?.url} className={classNames} ariaLabel={item.title} onClick={onClick}>
        {getContent()}
      </WLink>
    ) : (
      <div className={classNames}>{getContent()}</div>
    )
  ) : (
    <></>
  )
}

export default ProgettoCard
